import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useReports, useDeviceConfigEntries, useSystemId } from '../../../hooks/useReduxSelectors';
import { Accordion, AccordionSummary, Box, Button, CircularProgress, Divider, Paper, Stack, Typography } from '@mui/material';
import { fetchReports } from '../../../ducks/reportsDuck';
import { getReportUrl } from '../../../constants/apiUrl';
import { formatDateTime } from '../../../helpers/utils';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ReportSearchBar from '../reportSearchBar/ReportSearchBar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const sensorStateEnum = {
  "-1": "Undefinable",
  "0": "Normal",
  "1": "MinorBlockage",
  "3": "MajorBlockage",
  "5": "MinorLeakage",
  "9": "MajorLeakage",
  "6": "MinorBlockageAndMinorLeakage", // 1 + 5
  "10": "MinorBlockageAndMajorLeakage", // 1 + 9
  "8": "MajorBlockageAndMinorLeakage", // 3 + 5
  "12": "MajorBlockageAndMajorLeakage" // 3 + 9
};

const SteamtrapReport = () => {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const systemId = useSystemId();
  const { t } = useTranslation();
  const reports = useReports();
  const reportEntries = reports?.SteamTrapReport?.entries;

  console.log("reportEntries", reportEntries);


  // CONFIGS for devices. We need configs to find device/sensor name with HwId
  const devicesEntries = useDeviceConfigEntries();
  console.log("devicesEntries", devicesEntries);


  const findName = (HwId) => {
    const device = devicesEntries.find((device) => device.hwId === HwId);
    return device ? device.name : "No name";
  };

  const getColor = (State) => {
    switch (String(State)) {
      case "-1": // Undefinable
        return "grey";
      case "0": // Normal
        return "green";
      case "1": // MinorBlockage
        return "orange";
      case "3": // MajorBlockage
        return "red";
      case "5": // MinorLeakage
        return "orange";
      case "9": // MajorLeakage
        return "red";
      case "6": // MinorBlockageAndMinorLeakage (1+5)
        return "orange";
      case "10": // MinorBlockageAndMajorLeakage (1+9)
        return "red";
      case "8": // MajorBlockageAndMinorLeakage (3+5)
        return "red";
      case "12": // MajorBlockageAndMajorLeakage (3+9)
        return "red";
      default:
        return "grey";
    }
  };


  const createRows = (SensorName, DataPoints, HwId, State, index) => {
    if (!DataPoints) return null;

    console.log("DataPoints", DataPoints);

    return (
      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={index}>
        <TableCell component="th" scope="row">
          <Stack direction="column">
            <Typography fontWeight={500}>{SensorName}</Typography>
            <Typography fontSize={10} color="text.secondary">{HwId}</Typography>
          </Stack>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography color={getColor(State)}>{sensorStateEnum[State]?.replace(/([A-Z])/g, ' $1').trim()}</Typography>
        </TableCell>
        <TableCell component="th" scope="row">
          {DataPoints.EmpiricalLeakagePercentage?.Value.toFixed(1)} {DataPoints.EmpiricalLeakagePercentage?.Unit}
        </TableCell>
        <TableCell component="th" scope="row">
          {DataPoints.EmpiricalBlockagePercentage?.Value.toFixed(1)} {DataPoints.EmpiricalBlockagePercentage?.Unit}
        </TableCell>
        <TableCell component="th" scope="row">
          {DataPoints.TemperatureDelta?.Value.toFixed(1)} {DataPoints.TemperatureDelta?.Unit}
        </TableCell>
        <TableCell component="th" scope="row">
          {DataPoints.TIn?.Value.toFixed(1)} {DataPoints.TIn?.Unit}
        </TableCell>
        <TableCell component="th" scope="row">
          {DataPoints.TOut?.Value.toFixed(1)} {DataPoints.TOut?.Unit}
        </TableCell>


      </TableRow>
    );
  };



  return (
    <>
      <ReportSearchBar reportName="SteamTrapReport" />
      {reportEntries && reportEntries.length > 0 ? (
        <Box>
          {reportEntries.map((report, index) => (
            <Accordion key={index + "-" + report.ReportTimeStamp} defaultExpanded={index === 0 ? true : false} sx={{ margin: 1 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h5">{formatDateTime(report.ReportTimeStamp)}</Typography>
              </AccordionSummary>
              <Paper variant="outlined" sx={{ padding: 1, margin: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ margin: 1 }}>
                  <Typography variant="h5">Steamtrap Report</Typography>
                  <Typography variant="h5">{formatDateTime(report.ReportTimeStamp)}</Typography>
                </Stack>
                <Divider color="primary" />
                {console.log("report", report)}
                <Table size="small" aria-label="steamtrap table">
                  <TableHead>
                    <TableRow>
                      <TableCell><Typography fontWeight={500}>Name</Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>State </Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>Leakage %</Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>Blockage %</Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>Temperature Δ</Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>T-In </Typography></TableCell>
                      <TableCell><Typography fontWeight={500}>T-Out </Typography></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {report.Sensors?.flatMap((sensor, index) =>
                      createRows(sensor.SensorName, sensor.DataPoints, sensor.HwId, String(sensor.State), index)
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </Accordion>
          ))}
        </Box>
      ) : null}
    </>
  );
};

export default SteamtrapReport;;